import React, { Component } from "react";
import { FormGroup, Input } from "reactstrap";
import { generateUiAttributeAddressText } from "../Utils";

class AddressAttribute extends Component {
  static getDisplayValue(attributeValue) {
    return attributeValue.valueAddress
      ? generateUiAttributeAddressText(attributeValue.valueAddress)
      : null;
  }

  static getDisplayValueText(attributeValue) {
    return attributeValue.valueAddress
      ? attributeValue.valueAddress.text
      : null;
  }

  static getDisplayValueInFilter(av) {
    return av.valueAddress ? av.valueAddress.room : null;
  }

  render() {
    let { attributeValue, setData } = this.props;

    attributeValue.valueAddress = attributeValue.valueAddress || {};
    let addressVal = attributeValue.valueAddress;
    return (
      <div>
        <div className="d-flex">
          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.room}
            onChange={e => {
              attributeValue.valueAddress.room = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Room"
            onBlur={this.props.onBlur}
          />

          <Input
            className="my-1 ui-attribute-el"
            value={addressVal.floor}
            onChange={e => {
              attributeValue.valueAddress.floor = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Floor"
            onBlur={this.props.onBlur}
          />
        </div>
        <div className="d-flex">
          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.line ? addressVal.line[0] : ""}
            onChange={e => {
              attributeValue.valueAddress.line =
                attributeValue.valueAddress.line || [];
              attributeValue.valueAddress.line[0] = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Address Line 1"
            onBlur={this.props.onBlur}
          />

          <Input
            className="my-1 ui-attribute-el"
            value={addressVal.line ? addressVal.line[1] : ""}
            onChange={e => {
              attributeValue.valueAddress.line =
                attributeValue.valueAddress.line || [];
              attributeValue.valueAddress.line[1] = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Address Line 2"
            onBlur={this.props.onBlur}
          />
        </div>
        <div className="d-flex">
          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.city}
            onChange={e => {
              attributeValue.valueAddress.city = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="City"
            onBlur={this.props.onBlur}
          />

          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.county}
            onChange={e => {
              attributeValue.valueAddress.county = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="County"
            onBlur={this.props.onBlur}
          />

          <Input
            className="my-1 ui-attribute-el"
            value={addressVal.district}
            onChange={e => {
              attributeValue.valueAddress.district = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="District"
            onBlur={this.props.onBlur}
          />
        </div>

        <div className="d-flex">
          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.state}
            onChange={e => {
              attributeValue.valueAddress.state = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="State"
            onBlur={this.props.onBlur}
          />

          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.postalCode}
            onChange={e => {
              attributeValue.valueAddress.postalCode = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Postal Code"
            onBlur={this.props.onBlur}
          />

          <Input
            className="my-1 ui-attribute-el"
            value={addressVal.country}
            onChange={e => {
              attributeValue.valueAddress.country = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Country"
            onBlur={this.props.onBlur}
          />
        </div>
      </div>
    );
  }
}

export default AddressAttribute;
